exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-title {\n  margin-top: 15px;\n  margin-left: 15px; }\n\n.modal-body {\n  margin-left: 8%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/maintenance-modal/maintenance-modal.component.scss
// module id = 976
// module chunks = 1